import cx from 'classnames';
import get from 'lodash/get';
import orderBy from 'lodash/orderBy';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { withAppContext, withDesign } from '../Context';
import { Grid } from '../components';
import * as templates from '../items';
import { appDataProps } from '../utils/propTypes';
import BaseSection from './BaseSection';
import './DataItemSection.scss';

class DataItemSection extends PureComponent {
  getItems() {
    const { data, source } = this.props;
    if (!source) return [];
    const { dataType, collection, category, speakerIds } = source;
    if (!dataType || !collection) return []; // No data to show ?

    const items = get(data, ['data', dataType, collection]);
    if (!items) {
      // TODO: auto-fetch if missing ? Hide ?
      return [];
    }
    if (category) return items.filter((item) => item.category === category);
    if (collection === 'speakers' && speakerIds && speakerIds.length > 0) {
      return items.filter((item) => speakerIds.includes(item._id));
    }
    return items;
  }

  render() {
    const {
      className,
      gridSize,
      itemConfig,
      gridGapless,
      source,
      mobileGridSize = 1,
      ...props
    } = this.props;

    const items = this.getItems();

    const orderedItems = orderBy(items, itemConfig.orderBy);
    const Item = templates[itemConfig.component] || templates.CardItem;
    const isHexagonal = itemConfig.component === 'HexagonalItem';

    return (
      <BaseSection
        {...props}
        className={cx(
          className,
          `section section--DataItemSection--${source.dataType}-${source.collection}`,
          `section--DataItemSection-animated--${itemConfig.animation || 'none'}`,
        )}
        block={this.props}
      >
        <Grid
          items={orderedItems}
          gridSize={gridSize}
          isCentered
          tabletGridSize={Math.round(gridSize / 2)}
          mobileGridSize={mobileGridSize}
          // equalHeight
          isHexagonal={isHexagonal}
          isGapless={gridGapless}
        >
          {(item) => (
            <Item
              key={item._id}
              item={item}
              textAlign={itemConfig.textAlign}
              imageField={itemConfig.image}
              imageProps={itemConfig.imageProps}
              imagePlaceholder={itemConfig.imagePlaceholder}
              titleTemplate={itemConfig.title}
              subtitleTemplate={itemConfig.subtitle}
              descriptionTemplate={itemConfig.description}
              linkField={itemConfig.link}
              linkLabelTemplate={itemConfig.linkLabel}
            />
          )}
        </Grid>
      </BaseSection>
    );
  }
}

DataItemSection.defaultProps = {
  className: '',
  gridGapless: false,
  gridSize: 4,
  source: {},
  itemConfig: {
    textAlign: 'left',
    orderBy: undefined,
    animation: 'none',
  },
};

DataItemSection.propTypes = {
  className: PropTypes.string,
  data: appDataProps.isRequired,
  gridGapless: PropTypes.bool,
  gridSize: PropTypes.number,
  source: PropTypes.shape({
    dataType: PropTypes.string.isRequired,
    collection: PropTypes.string.isRequired,
    category: PropTypes.string,
    speakerIds: PropTypes.arrayOf(PropTypes.string),
  }),
  itemConfig: PropTypes.shape({
    component: PropTypes.string,
    textAlign: PropTypes.oneOf(['left', 'center', 'right']),
    orderBy: PropTypes.arrayOf(PropTypes.string),
    animation: PropTypes.oneOf(['none', 'scale-up', 'scale-down', 'move-up', 'move-down']),
  }),
};

export default withAppContext(withDesign(DataItemSection));
